import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import TouchPad from './TouchPad.js';
import { Wrapper } from './TouchPads.style.js';
import { getColorTheme } from './themes.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color", "bigPadText", "priceText", "smallPadText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TocuhPads = function TocuhPads(_ref) {
  var color = _ref.color,
    bigPadText = _ref.bigPadText,
    priceText = _ref.priceText,
    smallPadText = _ref.smallPadText,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!bigPadText) {
    return false;
  }
  var colorTheme = getColorTheme(color);
  return /*#__PURE__*/jsxs(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/jsx(TouchPad, {
      color: colorTheme.bigPadColor,
      text: bigPadText,
      priceText: priceText
    }), smallPadText && /*#__PURE__*/jsx(TouchPad, {
      color: colorTheme.smallPadColor,
      text: smallPadText,
      isSmall: true
    })]
  }));
};
TocuhPads.defaultProps = {
  color: 'dark-core',
  smallPadText: null,
  priceText: null
};
var TocuhPads$1 = TocuhPads;

export { TocuhPads$1 as default };
//# sourceMappingURL=TouchPads.js.map
